module.exports = __webpack_public_path__ + "img/9788972977117.75616825.jpg";